
import React, { useEffect, useRef, useState } from "react";
import sideImage from "./franchiesstore.jpg"; // ✅ Replace with your image path
import './Franchice.css';
const TextImageSplit = () => {
  const textRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setAnimate(true);
      },
      { threshold: 0.3 }
    );
    if (textRef.current) observer.observe(textRef.current);
    return () => {
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);

  return (
    <div style={styles.container}>
      {/* Top Center About Heading */}
      <h2 style={styles.sectionHeading}>About</h2>

      <div style={styles.wrapper} className="main-home-about">
        {/* Left Animated Text */}
        <div
          ref={textRef}
          style={{
            ...styles.left,
            transform: animate ? "translateY(0px)" : "translateY(50px)",
            opacity: animate ? 1 : 0,
            transition: "all 0.8s ease",
          }}
          className="lading-abouts"
        >
          <h1 style={styles.heading}>Welcome to Maamaas</h1>
          <p style={styles.description}>
            At Maamaas, we believe every business deserves the chance to grow — without heavy commissions, hidden costs, or complicated technology. That’s why we built India’s first zero-commission digital growth platform — designed to put your business in the spotlight while keeping you in full control of your earnings.
            <br></br><br></br>

            Step into the digital world effortlessly. With Maamaas, you can create a professional presence that showcases your services, menus, and branding. You’ll be discoverable by customers in your area and beyond, and manage everything from bookings to payments in one simple platform. No middlemen, no restrictions — just pure growth, on your terms. <br></br>


          </p>
        </div>

        {/* Right Image */}
        <div style={styles.right} className="lading-about">
          <img src={sideImage} alt="Business Visual" style={styles.image} />
        </div>
      </div>
    </div>
  );
};

// ✅ Inline Styles
const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px 10px",
  },
  sectionHeading: {
    textAlign: "center",
    fontSize: "28px",
    fontWeight: "bold",
    fontFamily: "'SF Pro', sans-serif",
    color: "#b15cd6",
    marginBottom: "10px",
    marginTop: "0px",
  },
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center", // ✅ Align items vertically
    justifyContent: "space-between",
    gap: "30px", // ✅ Gap between text and image
    width: "100%",
    maxWidth: "64vw",
    backgroundColor: "#f9f9f9",
    padding: "30px 20px",
    borderRadius: "12px",
  },
  left: {
    flex: "1 1 50%",
    // minWidth: "280px",
    marginTop: "10px",
  },
  right: {
    flex: "1 1 45%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // minWidth: "260px",
    marginTop: "10px",
  },
  heading: {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "15px",
    color: "#222",
  },
  description: {
    fontSize: "1rem",
    lineHeight: "1.6",
    color: "#555",
  },
  image: {
    width: "100%",
    maxWidth: "350px",
    height: "auto",
    borderRadius: "10px",
    objectFit: "cover",
  },
};

export default TextImageSplit;
